import React, { useEffect, useState } from 'react';
import { Menu, Flex } from 'antd';
import Icon from '@mdi/react';
import { mdiChartBar, mdiAccount, mdiChevronRight } from '@mdi/js';
import { useHistory, Link } from 'react-router-dom';
import P from 'router/paths';
import useQueryParams from 'hooks/useQueryParams';
import JourneyReport from 'modules/ReportModule/context/JourneyReport';
import useWorkspace from 'store/redux/hooks/useWorkspace';

const ReportMainMenu = ({ dateRangeComponent }) => {
  const { workspace } = useWorkspace();
  const selected_website_id = localStorage.getItem(`selected_website_id_${workspace.id}`);

  const history = useHistory();

  const { searchParams } = useQueryParams();
  const { user_id, website_id = selected_website_id } = searchParams;
  const appendQuery = (path) => `${path}?website_id=${website_id}`;

  const items = [
    {
      key: 'traffic_report',
      label: (
        <Link className='flex items-center gap-2' to={appendQuery(P.REPORT.INDEX)}>
          <Icon path={mdiChartBar} size={0.7} />
          Traffic Report
        </Link>
      ),
    },
  ];

  if (user_id) {
    items.push({
      key: 'user_journey',
      label: (
        <Flex className='items-center gap-1'>
          <Icon path={mdiAccount} size={0.7} />
          User Journey
          <Icon path={mdiChevronRight} size={0.8} />
          <span className='font-semibold'>{user_id}</span>
        </Flex>
      ),
      url: appendQuery(P.REPORT.INDEX),
    });
  }

  const [selected, setSelected] = useState('traffic_report');

  useEffect(() => {
    const activeKey = user_id ? 'user_journey' : 'traffic_report';
    setSelected(activeKey);
  }, [user_id]);

  const onSelect = ({ key }) => {
    const selectedItem = items.find((item) => item.key === key);
    if (selectedItem?.url) {
      history.push(selectedItem.url);
      setSelected(key);
    }
  };

  return (
    <div className='flex items-center justify-between gap-2 px-4 pr-8 mt-1 md:mb-0 mb-1 flex-wrap'>
      <Menu
        mode='horizontal'
        className='w-1/2 order-0 sm:order-1 !border-none'
        selectable={true}
        items={items}
        selectedKeys={[selected]}
        onSelect={onSelect}
        overflowedIndicator={null}
      />
      <div className='flex flex-wrap items-center gap-1 mb-2 sm:flex-nowrap order-1 sm:order-0 w-fit sm:mb-0'>
        <JourneyReport
          applyGlobally={true}
          shape='round'
          disableDate={true}
          date_key='trafficReportingOverview'
          headStyle={{ padding: 0, margin: 0, minHeight: 10, border: 'none' }}
        />
        <div className='w-full sm:max-w-44'>{dateRangeComponent}</div>
      </div>
    </div>
  );
};

export default ReportMainMenu;
